
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Eine Schlaf-App kann über das Mikrofon eines Smartphones aufnehmen, wie der Schläfer atmet und/oder schnarcht. Ebenso kann über verschiedene Funktionen festgestellt werden, wie stark er sich in der Nacht bewegt hat. Beim Zubettgehen gibt man ein, wann man am Morgen geweckt werden möchte, lässt das Handy am Strom angeschlossen und legt es z.B. auf den Nachttisch. Die Schlaf-App nimmt über das im Smartphone integrierte Mikrofon Atem- und Schnarchgeräusche auf. Ebenso kann durch die GPS-Ortung, den integrierten Kompass und die Höhenmessung festgestellt werden, wie stark die Person in der Nacht in Bewegung war. Am Morgen lässt sich feststellen, zu welchem Zeitpunkt man in welcher der drei Schlafphasen war und wie die App die Schlafqualität der letzten Nacht beurteilt. Mit Hilfe einer Grafik kann man diese so über Wochen und Monate verfolgen. Experten sind der Meinung, dass eine einfache Schlaf-App eine Tendenz, aber keine genauen Ergebnisse, liefert. `}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;